import React, { useEffect } from 'react';
import { Cell, CellProps } from '@blueprintjs/table';
import { ChainType, findInvalidSequenceCharacters } from './validation';

interface IProps extends CellProps {
    value: string;
    setValue: (value: string) => void;
    readOnly?: boolean;
    sequence?: string;
    onValidationError?: (error: string | null) => void;
}

const chainTypeOptions = Object.values(ChainType)
    .filter((type) => type !== ChainType.EMPTY)
    .map((type) => ({
        value: type,
        label: type,
    }));

export default function ChainTypeCell(props: IProps) {
    const { value, setValue, readOnly, sequence, onValidationError, ...cellProps } = props;

    useEffect(() => {
        if (sequence && value && value !== ChainType.EMPTY && onValidationError) {
            const invalidChars = findInvalidSequenceCharacters(sequence, value as ChainType);
            if (invalidChars.length > 0) {
                onValidationError(`Invalid character ("${invalidChars[0]}") for chain type ${value}`);
            } else {
                onValidationError(null);
            }
        } else if (onValidationError) {
            onValidationError(null);
        }
    }, [sequence, value, onValidationError]);
    return (
        <Cell
            className={cellProps.className}
            loading={cellProps.loading}
            style={{ ...cellProps.style, padding: 1, margin: 0 }}
            cellRef={cellProps.cellRef}
        >
            <select
                className='text-gray-900 text-sm border-0 pl-2 font-gray-500 p-0 focus:outline-none focus:ring-2 focus:ring-blue-500'
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={readOnly}
                style={{ width: '100%', height: '100%' }}
            >
                <option value='' disabled={true} hidden={true} />
                {chainTypeOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </Cell>
    );
}
